export default __webpack_public_path__ + "static/media/6.e28e871a.png";